module.exports = __webpack_public_path__ + "static/team-section-5ef0efdd2f8cd183fa1da8375dd2c09a.png";